<template>
  <div class="home">
    <h1 class="subheading white--text">Dashboard</h1>
    <v-container class="my-5">
      <v-layout row class="mb-3">
        <v-tooltip top>
          <v-btn small flat color="white" @click="sortBy('name')" slot="activator">
            <v-icon left small>folder</v-icon>
            <span class="caption text-lowercase">By store name</span>
          </v-btn>
          <span>Sort stores by store name</span>
        </v-tooltip>
        <v-tooltip top>
          <v-btn small flat color="white" @click="sortBy('owner')" slot="activator">
            <v-icon left small>person</v-icon>
            <span class="caption text-lowercase">By owner name</span>
          </v-btn>
          <span>Sort stores by owners</span>
        </v-tooltip>
      </v-layout>

      <v-card flat v-for="store in stores" :key="store.name">
        <v-layout row wrap justify-center :class="`dark pa-3 project ${store.status}`">
          <v-flex xs12 md4>
            <div class="caption white--text">Store name</div>
            <div class="light--text">{{store.name}}</div>
          </v-flex>
          <v-flex xs4 sm4 md2>
            <div class="caption white--text">Type</div>
            <div class="light--text">{{store.type}}</div>
          </v-flex>
          <v-flex xs6 sm4 md2>
            <div class="caption white--text">Owner</div>
            <div class="light--text">{{store.owner}}</div>
          </v-flex>
          <v-flex xs4 sm4 md2>
            <div>
              <v-chip
                :class="`text-capitalize ${store.status} white--text caption my-2`"
                small
              >{{store.status}}</v-chip>
            </div>
          </v-flex>
          <v-flex xs7 sm11 md2>
            <v-btn color="primary" depressed block class="left">
              <v-icon>arrow_forward</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
        <v-divider class="primary"></v-divider>
      </v-card>
    </v-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      stores: [
        {
          name: "Banzai",
          type: "Sport",
          owner: "Lilahamstern",
          status: "active"
        },
        {
          name: "Ica Maxi",
          type: "Super store",
          owner: "Eva",
          status: "inactive"
        },
        {
          name: "Supermarket",
          type: "Super store",
          owner: "Kent",
          status: "inactive"
        }
      ]
    };
  },
  methods: {
    sortBy(prop) {
      this.stores.sort((a, b) => (a[prop] < b[prop] ? -1 : 1));
    }
  }
};
</script>

<style lang="scss">
.project.active {
  border-left: 4px solid green;
}
.project.inactive {
  border-left: 4px solid red;
}

.v-chip.active {
  background: green;
}
.v-chip.inactive {
  background: red;
}
</style>

